import React from "react";
import InnerHero from "../components/InnerHero";

const recognitionImages = [
  "IMG-20260203-WA0039.jpg",
  "Carrer 360.jpg",
  "image15.png",
  "col.jpg",
  "Seema b award.jpeg",
  "image1.png",
  "IMG-20260122-WA0074.jpg",
  "image12.png",
  "image21.jpeg",
  "image14.png",
  "IMG-20260121-WA0009.jpg",
  "Cancer Hospital Appriciation.jpg",
  "image7.jpeg",
  "image17.png",
  "Screenshot_20260104_082252_Chrome.jpg",
  "UPSC 739 rank KLS VDIT.jpg",
  "Kannada Kalasha 2024.jpg",
  "IMG-20260402-WA0020.jpg",
  "image10.png",
  "20260122_213005.jpg",
  "IEI award details.jpg",
  "image9.png",
  "image8.png",
  "image11.png",
  "image19.jpeg",
  "image22.jpeg",
  "UPSC.jpg",
  "image18.png",
  "image13.jpeg",
  "image3.jpeg",
  "MOU Russia.jpg",
  "Gate clear 1.jpg",
  "platinum award.jpg",
  "Rossia MoU.jpg",
  "image16.png",
];

const getTitle = (fileName) =>
  fileName
    .replace(/\.[^.]+$/, "")
    .replace(/[-_]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const AwardsRecognition = () => (
  <main>
    <InnerHero
      title="Awards & Recognition"
      image="/Recognitions/platinum award.jpg"
      breadcrumbs={[
        { label: "About" },
        { label: "Awards & Recognition" },
      ]}
    />

    <section className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {recognitionImages.map((fileName) => (
          <article
            key={fileName}
            className="bg-white border border-brand/15 overflow-hidden shadow-sm"
          >
            <div className="aspect-[4/3] bg-surface-alt">
              <img
                src={`/Recognitions/${fileName}`}
                alt={getTitle(fileName)}
                className="w-full h-full object-contain"
                loading="lazy"
              />
            </div>
            {/* <div className="p-4 border-t border-brand/10">
              <h2 className="text-brand font-semibold leading-snug">
                {getTitle(fileName)}
              </h2>
            </div> */}
          </article>
        ))}
      </div>
    </section>
  </main>
);

export default AwardsRecognition;